import { useState } from 'react';
import { waitlistService, WaitlistEntry } from '../services/WaitlistService';

export const useWaitlist = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [submitted, setSubmitted] = useState(false);

    const submitWaitlist = async (email: string, userType: 'tutor' | 'client' | '', comments: string) => {
        setLoading(true);
        setError(null);
        try {
            const entry: WaitlistEntry = {
                email,
                userType,
                comments,
                timestamp: new Date(),
            };
            await waitlistService.addToWaitlist(entry);
            setSubmitted(true);
        } catch (err: any) {
            setError(err.message || 'Failed to join waitlist');
        } finally {
            setLoading(false);
        }
    };

    return {
        submitWaitlist,
        loading,
        error,
        submitted,
    };
};
